<template>
  <v-container v-if="user && currentUser" fill-height fluid pa-10>
    <!-- Loading Cover -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-content">
        <!-- Aquí puedes poner tu logo o cualquier elemento de carga -->
        <img src="@/assets/log.png" alt="Cargando..." class="loading-logo" />
      </div>
    </div>

    <v-row v-else align="center" justify="center">
      <h2 class="text-center">
        Hola {{ this.currentUser.nombre }}, Bienvenido a la página de faltantes
        de <br />
        Central Express de Control de plagas S.A. de C.V.
      </h2>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/pedidos"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/write-order-order-online-shop-svgrepo-com.svg"
            alt="Pedidos"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Pedidos</span>
        </v-btn>
      </v-col>
      <v-col
        v-if="this.currentUser.nombre_adminpaq != null"
        cols="12"
        md="4"
        offset-md="1"
        class="mt-4"
      >
        <v-btn
          color="glass-effect"
          link
          to="/pedidos_vendedores"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/write-order-order-online-shop-svgrepo-com.svg"
            alt="Pedidos"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Mis Pedidos</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/precios_existencias"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/outline-price-red-svgrepo-com.svg"
            alt="Precios y Existencias"
            style="height: 90px; margin-bottom: 8px"
          />
          <span>Precios y Existencias</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/clientes"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/user-svgrepo-com.svg"
            alt="Clientes"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Clientes</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/mis_clientes"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/user-tie-svgrepo-com.svg"
            alt="Mis Clientes"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Mis Clientes</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
  },
  mounted() {
    // Simular una carga de datos
    setTimeout(() => {
      this.isLoading = false;
    }, 2000); // Cambia el tiempo según tus necesidades
  },
};
</script>

<style scoped>
.glass-effect {
  border-radius: 10px;
  background-color: rgba(42, 202, 207, 0.3);
  border: 1px solid rgba(98, 97, 97, 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 0 10px rgba(33, 158, 197, 0.3);
  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    backdrop-filter 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.glass-effect:hover {
  background-color: rgba(128, 203, 196, 0.5);
  border-color: rgba(38, 151, 166, 0.5);
  box-shadow: 0 0 15px rgba(33, 158, 198, 0.5);
}

/* Overlay que cubre toda la pantalla */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-out;
}

/* Contenido de carga (logo o spinner) */
.loading-content {
  text-align: center;
}

.loading-logo {
  width: 80px;
  margin-bottom: 10px;
  animation: s7 2s infinite linear;
}

@keyframes s7 {
  0% {
    transform: rotateY(0deg);
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    transform: rotatey(360deg);
    opacity: 1;
  }
}
/* Efecto de desvanecimiento cuando el loading desaparece */
.loading-overlay.v-leave-active {
  opacity: 0;
}
</style>
